import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import Model from "./Model";
export default class Payment extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'id',
      content: null
    });
    _defineProperty(this, "PaymentId", {
      fieldName: 'payment_reference_id',
      content: null
    });
    _defineProperty(this, "paymentMethod", {
      fieldName: 'payment_method',
      content: null
    });
  }
  getPaymentMethod() {
    return this.paymentMethod.content;
  }
}
_defineProperty(Payment, "PAID_STATUS", 'paid');
_defineProperty(Payment, "NOT_PAID_STATUS", 'not-paid');
_defineProperty(Payment, "PARTIALLY_PAID_STATUS", 'partially-paid');
_defineProperty(Payment, "FAILED_STATUS", 'failed');
_defineProperty(Payment, "CARD_PAYMENT_METHOD", 'card');
_defineProperty(Payment, "GOOGLE_PAY_PAYMENT_METHOD", 'google_pay');
_defineProperty(Payment, "APPLE_PAY_PAYMENT_METHOD", 'apple_pay');
_defineProperty(Payment, "UNKNOWN_PAYMENT_METHOD", 'unknown');